/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';
import { CpdsBackgroundTypes } from '../const';
import { cpdsMediaQueryVals } from '../../token/shared/common';

const colorMapper = (props, token) => {
  let borderColor, background, fontColor;
  switch (props?.background) {
    case CpdsBackgroundTypes.PRIMARY:
      borderColor = token.cpds_transpoter_border_color_primary;
      background = token.cpds_transpoter_background_color_primary;
      fontColor = token.cpds_transpoter_font_color_primary;
      break;
    case CpdsBackgroundTypes.SECONDARY:
      borderColor = token.cpds_transpoter_border_color_secondary;
      background = token.cpds_transpoter_background_color_secondary;
      fontColor = token.cpds_transpoter_font_color_primary;
      break;
    case CpdsBackgroundTypes.TERTIARY:
      borderColor = token.cpds_transpoter_border_color_primary;
      background = token.cpds_transpoter_background_color_primary;
      fontColor = token.cpds_transpoter_font_color_primary;
      break;
    default:
      borderColor = token.cpds_transpoter_border_color_primary;
      background = token.cpds_transpoter_background_color_primary;
      fontColor = token.cpds_transpoter_font_color_primary;

  }

  return {
    borderColor,
    background,
    fontColor
  };
};

const CpdsTranspoterContainer = styled.div`
  ${({ theme: { styles : {cpds} }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const styleOverrides = props?.styleOverrides
    const { borderColor, background, fontColor } = colorMapper(props, token)
    return css`   
      display: flex;
      align-items: center;
      width: 100%;
      text-align: center;
      margin: 20px 0;
      color: ${fontColor}; /* Color of the text */
      padding: 72px 56px;
      background: ${background};
      &::before,
      &::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid ${borderColor}; /* Divider line color */
      }

      &::before {
        margin-right: 56px;
      }

      &::after {
        margin-left: 56px;
      }

      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
        padding: 32px 16px;

        &::before {
          margin-right: 16px;
        }

        &::after {
          margin-left: 16px;
        }
      }
      
      ${styleOverrides}
  `}
  }
`;

const CpdsTranspoterText = styled.span`
    ${({ theme: { styles : {cpds} }, props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { fontColor } = colorMapper(props, token)
    return css`   
      color: ${fontColor}; /* Adjust text color */
  `}
  }
  
`;


export { CpdsTranspoterContainer, CpdsTranspoterText };
